import { useContext } from 'react';

import { SimulationContext } from '../context/SimulationContext';

export const useSimulationContext = () => {
  return useContext(SimulationContext);
};
